import { Box, Typography } from '@mui/material';
const LabelValueItem = ({ label, value }) => (
    <Box>
        <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: 'block', mb: 0.5 }}
        >
            {label}
        </Typography>
        <Typography fontWeight={500}>
            {value || '-'}
        </Typography>
    </Box>
);
export default LabelValueItem;
